// Spanish strings. Typed as `Translations`, so any key missing from — or not
// present in — en.ts is a compile error.

import type { Translations } from './en';

export const es: Translations = {
  // ── app / navegación ──────────────────────────────────────────────────────
  'app.name': 'ARES Invoice',
  'app.tagline': 'Facturación, clientes y productos',
  'nav.invoices': 'Facturas',
  'nav.clients': 'Clientes',
  'nav.products': 'Productos',
  'nav.users': 'Usuarios',
  'nav.settings': 'Configuración',
  'nav.signOut': 'Salir',
  'nav.language': 'Idioma',
  'nav.menu': 'Menú',

  // ── común ─────────────────────────────────────────────────────────────────
  'common.save': 'Guardar',
  'common.saveChanges': 'Guardar cambios',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.new': 'Nuevo',
  'common.search': 'Buscar',
  'common.searchPlaceholder': 'Buscar…',
  'common.clear': 'Limpiar',
  'common.loading': 'Cargando…',
  'common.saving': 'Guardando…',
  'common.noResults': 'Sin resultados',
  'common.noResultsHint': 'Prueba con otro término de búsqueda.',
  'common.required': 'Obligatorio',
  'common.optional': 'opcional',
  'common.active': 'Activo',
  'common.inactive': 'Inactivo',
  'common.status': 'Estado',
  'common.actions': 'Acciones',
  'common.created': 'Creado',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.retry': 'Reintentar',
  'common.saved': 'Guardado',
  'common.deleted': 'Eliminado',
  'common.of': 'de',
  'common.page': 'Página {page} de {total}',
  'common.showing': 'Mostrando {from}–{to} de {total}',
  'common.previous': 'Anterior',
  'common.next': 'Siguiente',
  'common.all': 'Todas',
  'common.total': 'Total',
  'common.unsavedChanges': 'Tienes cambios sin guardar. ¿Salir de todos modos?',

  // ── acceso ────────────────────────────────────────────────────────────────
  'login.title': 'Iniciar sesión',
  'login.subtitle': 'Inicia sesión para continuar',
  'login.username': 'Usuario o correo electrónico',
  'login.password': 'Contraseña',
  'login.submit': 'Iniciar sesión',
  'login.signingIn': 'Iniciando sesión…',
  'login.signedOut': 'Has cerrado la sesión.',

  // ── facturas ──────────────────────────────────────────────────────────────
  'invoices.title': 'Facturas',
  'invoices.new': 'Nueva factura',
  'invoices.searchPlaceholder': 'Nombre del cliente o número de factura',
  'invoices.number': 'Nº',
  'invoices.date': 'Fecha',
  'invoices.client': 'Cliente',
  'invoices.seller': 'Emitida por',
  'invoices.lines': 'Líneas',
  'invoices.empty': 'Todavía no hay facturas',
  'invoices.emptyHint': 'Crea tu primera factura para empezar.',
  'invoices.download': 'Descargar PDF',
  'invoices.deleteConfirm': '¿Eliminar la factura nº {number}? Esta acción no se puede deshacer.',
  'invoices.deleted': 'Factura nº {number} eliminada',
  'invoices.markPaid': 'Marcar como pagada',
  'invoices.markPending': 'Marcar como pendiente',
  'invoices.markedPaid': 'Factura nº {number} marcada como pagada',
  'invoices.markedPending': 'Factura nº {number} marcada como pendiente',
  'invoices.filterStatus': 'Estado',
  'invoices.totals.invoices': 'Facturas',
  'invoices.totals.net': 'Base',
  'invoices.totals.tax': 'Impuesto',
  'invoices.totals.gross': 'Total',
  'invoices.totals.outstanding': 'Pendiente de cobro',

  // ── editor de factura ─────────────────────────────────────────────────────
  'invoice.new.title': 'Nueva factura',
  'invoice.edit.title': 'Factura nº {number}',
  'invoice.field.client': 'Cliente',
  'invoice.field.clientPlaceholder': 'Escribe para buscar clientes…',
  'invoice.field.phone': 'Teléfono',
  'invoice.field.email': 'Correo electrónico',
  'invoice.field.seller': 'Emitida por',
  'invoice.field.date': 'Fecha',
  'invoice.field.paymentMethod': 'Forma de pago',
  'invoice.field.status': 'Estado',
  'invoice.field.notes': 'Notas',
  'invoice.field.notesPlaceholder': 'Se muestran en el documento, debajo de los totales',
  'invoice.selectClient': 'Selecciona primero un cliente',
  'invoice.addLine': 'Añadir producto',
  'invoice.addLines': 'Añadir productos',
  'invoice.newClient': 'Nuevo cliente',
  'invoice.newProduct': 'Nuevo producto',
  'invoice.lines.code': 'Código',
  'invoice.lines.quantity': 'Cant.',
  'invoice.lines.description': 'Descripción',
  'invoice.lines.unitPrice': 'Precio unit.',
  'invoice.lines.lineTotal': 'Precio total',
  'invoice.lines.remove': 'Quitar línea',
  'invoice.lines.empty': 'Todavía no se han añadido productos',
  'invoice.lines.emptyHint': 'Usa «Añadir productos» para componer el documento.',
  'invoice.subtotal': 'Base imponible',
  'invoice.tax': 'IVA ({rate}%)',
  'invoice.total': 'Total',
  'invoice.save': 'Guardar factura',
  'invoice.created': 'Factura nº {number} creada',
  'invoice.updated': 'Factura nº {number} actualizada',
  'invoice.taxRateNote': 'El tipo de impuesto se toma de Configuración al crear el documento y luego queda fijado.',
  'invoice.picker.title': 'Añadir productos',
  'invoice.picker.add': 'Añadir',
  'invoice.picker.added': '{name} añadido',
  'invoice.picker.searchPlaceholder': 'Buscar por código o nombre',

  // ── formas de pago / estados ──────────────────────────────────────────────
  'payment.cash': 'Efectivo',
  'payment.check': 'Cheque',
  'payment.transfer': 'Transferencia bancaria',
  'payment.credit': 'Crédito',
  'status.paid': 'Pagada',
  'status.pending': 'Pendiente',

  // ── clientes ──────────────────────────────────────────────────────────────
  'clients.title': 'Clientes',
  'clients.new': 'Nuevo cliente',
  'clients.edit': 'Editar cliente',
  'clients.searchPlaceholder': 'Nombre, CIF/NIF, teléfono o correo',
  'clients.field.name': 'Nombre',
  'clients.field.taxId': 'CIF / NIF',
  'clients.field.phone': 'Teléfono',
  'clients.field.email': 'Correo electrónico',
  'clients.field.address': 'Dirección',
  'clients.invoices': 'Facturas',
  'clients.empty': 'Todavía no hay clientes',
  'clients.emptyHint': 'Añade un cliente para empezar a facturar.',
  'clients.deleteConfirm': '¿Eliminar a {name}?',
  'clients.deleteBlocked': '{name} tiene {count} factura(s) y no se puede eliminar. Márcalo como inactivo.',
  'clients.created': 'Cliente creado',
  'clients.updated': 'Cliente actualizado',

  // ── productos ─────────────────────────────────────────────────────────────
  'products.title': 'Productos',
  'products.new': 'Nuevo producto',
  'products.edit': 'Editar producto',
  'products.searchPlaceholder': 'Código o nombre',
  'products.field.code': 'Código',
  'products.field.name': 'Descripción',
  'products.field.unitPrice': 'Precio unitario',
  'products.empty': 'Todavía no hay productos',
  'products.emptyHint': 'Añade un producto para incluirlo en las facturas.',
  'products.deleteConfirm': '¿Eliminar {name}?',
  'products.deleteKeepsHistory': 'Las facturas ya emitidas conservan su copia de este producto.',
  'products.created': 'Producto creado',
  'products.updated': 'Producto actualizado',

  // ── usuarios ──────────────────────────────────────────────────────────────
  'users.title': 'Usuarios',
  'users.new': 'Nuevo usuario',
  'users.edit': 'Editar usuario',
  'users.searchPlaceholder': 'Nombre, usuario o correo',
  'users.field.firstName': 'Nombre',
  'users.field.lastName': 'Apellidos',
  'users.field.username': 'Usuario',
  'users.field.email': 'Correo electrónico',
  'users.field.password': 'Contraseña',
  'users.field.passwordRepeat': 'Repetir contraseña',
  'users.field.locale': 'Idioma',
  'users.changePassword': 'Cambiar contraseña',
  'users.passwordChanged': 'Contraseña cambiada',
  'users.passwordHint': 'Mínimo 8 caracteres.',
  'users.deleteConfirm': '¿Eliminar a {name}?',
  'users.deleteBlocked': '{name} ha emitido {count} factura(s) y no se puede eliminar. Márcalo como inactivo.',
  'users.deleteSelf': 'No puedes eliminar la cuenta con la que has iniciado sesión.',
  'users.created': 'Usuario creado',
  'users.updated': 'Usuario actualizado',
  'users.you': 'tú',

  // ── configuración ─────────────────────────────────────────────────────────
  'settings.title': 'Configuración',
  'settings.company': 'Empresa',
  'settings.invoicing': 'Facturación',
  'settings.appearance': 'Apariencia',
  'settings.field.companyName': 'Nombre de la empresa',
  'settings.field.taxId': 'CIF / NIF',
  'settings.field.address': 'Dirección',
  'settings.field.city': 'Ciudad',
  'settings.field.region': 'Región / provincia',
  'settings.field.postalCode': 'Código postal',
  'settings.field.phone': 'Teléfono',
  'settings.field.email': 'Correo electrónico',
  'settings.field.taxRate': 'IVA (%)',
  'settings.field.currency': 'Moneda',
  'settings.field.defaultLocale': 'Idioma predeterminado',
  'settings.logo': 'Logotipo',
  'settings.logoUpload': 'Subir logotipo',
  'settings.logoHint': 'PNG o JPEG, hasta 2 MB. Aparece en todas las facturas en PDF.',
  'settings.logoRemove': 'Quitar logotipo',
  'settings.taxRateHint': 'Se aplica a las facturas creadas a partir de ahora. Las existentes conservan el tipo con el que se emitieron.',
  'settings.saved': 'Configuración guardada',

  // ── PDF ───────────────────────────────────────────────────────────────────
  'pdf.invoice': 'FACTURA',
  'pdf.invoiceNumber': 'Factura nº',
  'pdf.date': 'FECHA',
  'pdf.paymentMethod': 'FORMA DE PAGO',
  'pdf.billTo': 'FACTURAR A',
  'pdf.taxId': 'CIF',
  'pdf.phone': 'Teléfono',
  'pdf.email': 'Email',
  'pdf.quantity': 'CANT.',
  'pdf.description': 'DESCRIPCIÓN',
  'pdf.unitPrice': 'PRECIO UNIT.',
  'pdf.lineTotal': 'PRECIO TOTAL',
  'pdf.subtotal': 'BASE IMPONIBLE',
  'pdf.tax': 'IVA ({rate}%)',
  'pdf.total': 'TOTAL',
  'pdf.page': 'Página {page} de {total}',
  'pdf.issuedBy': 'Emitida por',
  'pdf.notes': 'Notas',

  // ── presupuestos ──────────────────────────────────────────────────────────
  'nav.quotations': 'Presupuestos',
  'quotations.title': 'Presupuestos',
  'quotations.new': 'Nuevo presupuesto',
  'quotations.searchPlaceholder': 'Nombre del cliente o número de presupuesto',
  'quotations.number': 'Nº',
  'quotations.validUntil': 'Válido hasta',
  'quotations.empty': 'Todavía no hay presupuestos',
  'quotations.emptyHint': 'Presupuesta a un cliente antes de facturarle.',
  'quotations.deleteConfirm': '¿Eliminar el presupuesto nº {number}? Esta acción no se puede deshacer.',
  'quotations.deleted': 'Presupuesto nº {number} eliminado',
  'quotations.download': 'Descargar PDF',
  'quotations.totals.quotations': 'Presupuestos',
  'quotations.totals.open': 'Valor abierto',
  'quotations.totals.accepted': 'Aceptados',
  'quotation.new.title': 'Nuevo presupuesto',
  'quotation.edit.title': 'Presupuesto nº {number}',
  'quotation.save': 'Guardar presupuesto',
  'quotation.created': 'Presupuesto nº {number} creado',
  'quotation.updated': 'Presupuesto nº {number} actualizado',
  'quotation.field.validUntil': 'Válido hasta',
  'quotation.validityHint': 'Se muestra en el presupuesto. Pasada esta fecha se marca como caducado.',
  'quotation.convert': 'Convertir en factura',
  'quotation.convertConfirm': '¿Crear una factura a partir del presupuesto nº {number}?\n\nLa factura conserva el tipo de impuesto y la moneda presupuestados, de modo que al cliente se le factura exactamente lo presupuestado.',
  'quotation.converted': 'Factura nº {number} creada a partir del presupuesto',
  'quotation.convertedBanner': 'Convertido en la factura nº {number}.',
  'quotation.convertedOpen': 'Abrir la factura',
  'quotation.alreadyConverted': 'Este presupuesto ya se ha convertido en factura.',
  'quotation.fromQuotation': 'Del presupuesto nº {number}',
  'status.draft': 'Borrador',
  'status.sent': 'Enviado',
  'status.accepted': 'Aceptado',
  'status.rejected': 'Rechazado',
  'status.expired': 'Caducado',

  // ── correo ────────────────────────────────────────────────────────────────
  'email.send': 'Enviar por correo',
  'email.title': 'Enviar por correo',
  'email.to': 'Para',
  'email.cc': 'Cc',
  'email.subject': 'Asunto',
  'email.message': 'Mensaje',
  'email.attachment': 'Adjunto',
  'email.sendButton': 'Enviar',
  'email.sending': 'Enviando…',
  'email.sent': 'Enviado a {to}',
  'email.lastSent': 'Enviado por correo el {date}',
  'email.noClientAddress': 'Este cliente no tiene correo electrónico. Introduce uno abajo.',
  'email.invoiceSubject': 'Factura {number} — {company}',
  'email.quotationSubject': 'Presupuesto {number} — {company}',
  'email.invoiceBody': 'Estimado/a {client}:\n\nAdjuntamos la factura {number} de fecha {date}, por un importe de {total}.\n\n{payment}\n\nUn cordial saludo,\n{company}',
  'email.quotationBody': 'Estimado/a {client}:\n\nAdjuntamos el presupuesto {number}, por un importe de {total}. Es válido hasta el {validUntil}.\n\nQuedamos a su disposición para cualquier consulta.\n\nUn cordial saludo,\n{company}',
  'email.bodyPayment': 'El pago puede realizarse en la cuenta: {account}',
  'email.notConfigured': 'El correo no está configurado. Rellena el servidor de correo en Ajustes.',
  'email.failed': 'No se ha podido enviar el mensaje. Revisa el servidor de correo en Ajustes.',
  'email.invalidRecipient': 'Introduce un correo electrónico válido.',

  // ── datos bancarios ───────────────────────────────────────────────────────
  'settings.payment': 'Datos de pago',
  'settings.field.bankName': 'Banco',
  'settings.field.bankAccount': 'Cuenta bancaria / IBAN',
  'settings.bankHint': 'Se imprime al pie de cada factura y presupuesto en PDF.',
  'pdf.bankAccount': 'Cuenta bancaria',
  'pdf.quotation': 'PRESUPUESTO',
  'pdf.quotationNumber': 'Presupuesto nº',
  'pdf.validUntil': 'VÁLIDO HASTA',

  // ── verificación en dos pasos ─────────────────────────────────────────────
  'twofactor.title': 'Verificación en dos pasos',
  'twofactor.required': 'La verificación en dos pasos es obligatoria en todas las cuentas.',
  'twofactor.setUp': 'Configurar la verificación en dos pasos',
  'twofactor.setUpIntro': 'Escanea este código con una aplicación de autenticación —Google Authenticator, Authy, 1Password o similar— e introduce después el código de seis dígitos que muestre.',
  'twofactor.manualEntry': '¿No puedes escanear? Introduce esta clave a mano',
  'twofactor.code': 'Código de verificación',
  'twofactor.codePlaceholder': '000000',
  'twofactor.codeHint': 'Seis dígitos de tu aplicación de autenticación.',
  'twofactor.confirm': 'Confirmar y continuar',
  'twofactor.challengeTitle': 'Código de verificación',
  'twofactor.challengeIntro': 'Introduce el código de tu aplicación de autenticación.',
  'twofactor.useRecovery': 'Usar un código de recuperación',
  'twofactor.useAuthenticator': 'Usar la aplicación de autenticación',
  'twofactor.recoveryCode': 'Código de recuperación',
  'twofactor.recoveryPlaceholder': 'XXXXX-XXXXX',
  'twofactor.recoveryHint': 'Uno de los códigos que guardaste al configurarlo. Cada uno sirve una sola vez.',
  'twofactor.verify': 'Verificar',
  'twofactor.verifying': 'Verificando…',
  'twofactor.invalidCode': 'Ese código no es correcto. Revisa tu aplicación e inténtalo de nuevo.',
  'twofactor.locked': 'Demasiados códigos incorrectos. Inténtalo de nuevo en unos minutos.',
  'twofactor.notStarted': 'Vuelve a empezar la configuración: no hay ninguna pendiente.',
  'twofactor.notEnrolled': 'Esta cuenta no ha terminado de configurar la verificación en dos pasos.',
  'twofactor.recoveryTitle': 'Guarda tus códigos de recuperación',
  'twofactor.recoveryIntro': 'Cada código sirve una vez y te permite entrar si pierdes el teléfono. Guárdalos en un lugar seguro: no se vuelven a mostrar.',
  'twofactor.recoveryDownload': 'Descargar',
  'twofactor.recoveryCopy': 'Copiar',
  'twofactor.recoveryCopied': 'Copiado',
  'twofactor.recoveryAcknowledge': 'He guardado estos códigos',
  'twofactor.recoveryRemaining': 'Quedan {count} códigos de recuperación',
  'twofactor.recoveryLow': 'Sólo quedan {count} códigos de recuperación. Genera un juego nuevo.',
  'twofactor.recoveryUsed': 'Has entrado con un código de recuperación. Quedan {count}.',
  'twofactor.regenerate': 'Generar códigos de recuperación nuevos',
  'twofactor.regenerated': 'Códigos de recuperación nuevos generados. Los anteriores ya no sirven.',
  'twofactor.status': 'Estado',
  'twofactor.enabledSince': 'Activa desde el {date}',
  'twofactor.reconfigure': 'Configurar un dispositivo nuevo',
  'twofactor.reconfigureHint': 'Sustituye tu aplicación actual. La anterior deja de funcionar de inmediato.',
  'twofactor.confirmPassword': 'Confirma tu contraseña para continuar',
  'twofactor.adminReset': 'Restablecer la verificación en dos pasos',
  'twofactor.adminResetConfirm': '¿Restablecer la verificación en dos pasos de {name}?\n\nSu aplicación y sus códigos de recuperación dejarán de funcionar, y volverá a configurarla la próxima vez que inicie sesión.',
  'twofactor.adminResetDone': 'Verificación en dos pasos restablecida para {name}',
  'twofactor.adminResetHint': 'Úsalo cuando alguien haya perdido el teléfono y los códigos de recuperación.',
  'twofactor.notConfigured': 'Sin configurar',
  'twofactor.security': 'Seguridad',
  'twofactor.myAccount': 'Mi cuenta',

  // ── proveedores y facturas recibidas ──────────────────────────────────────
  'nav.purchases': 'Compras',
  'suppliers.title': 'Proveedores',
  'suppliers.new': 'Nuevo proveedor',
  'suppliers.edit': 'Editar proveedor',
  'suppliers.searchPlaceholder': 'Nombre, CIF/NIF o correo',
  'suppliers.field.name': 'Nombre',
  'suppliers.field.taxId': 'CIF / NIF',
  'suppliers.field.phone': 'Teléfono',
  'suppliers.field.email': 'Correo electrónico',
  'suppliers.field.address': 'Dirección',
  'suppliers.field.notes': 'Notas',
  'suppliers.empty': 'Todavía no hay proveedores',
  'suppliers.emptyHint': 'Añade los proveedores y fabricantes que te facturan.',
  'suppliers.invoices': 'Facturas',
  'suppliers.billed': 'Facturado',
  'suppliers.created': 'Proveedor creado',
  'suppliers.updated': 'Proveedor actualizado',
  'suppliers.deleteConfirm': '¿Eliminar a {name}?',
  'suppliers.deleteBlocked': '{name} tiene {count} factura(s) y no se puede eliminar. Márcalo como inactivo.',
  'purchases.title': 'Facturas de proveedores',
  'purchases.subtitle': 'Facturas recibidas de proveedores',
  'purchases.new': 'Registrar factura',
  'purchases.edit': 'Editar factura de proveedor',
  'purchases.searchPlaceholder': 'Proveedor, número o descripción',
  'purchases.empty': 'Todavía no hay facturas de proveedores',
  'purchases.emptyHint': 'Sube una factura que te haya enviado un proveedor.',
  'purchases.field.supplier': 'Proveedor',
  'purchases.field.number': 'Número de factura',
  'purchases.field.numberHint': 'La referencia del propio proveedor.',
  'purchases.field.issuedOn': 'Fecha de la factura',
  'purchases.field.receivedOn': 'Recibida',
  'purchases.field.dueOn': 'Vencimiento',
  'purchases.field.description': 'Descripción',
  'purchases.field.subtotal': 'Base imponible',
  'purchases.field.taxTotal': 'IVA',
  'purchases.field.total': 'Total',
  'purchases.field.status': 'Estado',
  'purchases.field.paidOn': 'Fecha de pago',
  'purchases.field.notes': 'Notas',
  'purchases.amountsHint': 'Introduce los importes tal como aparecen en la factura. El total es la suma.',
  'purchases.file': 'Archivo de la factura',
  'purchases.fileUpload': 'Subir archivo',
  'purchases.fileReplace': 'Sustituir archivo',
  'purchases.fileRemove': 'Quitar archivo',
  'purchases.fileHint': 'PDF, PNG o JPEG, hasta 10 MB. Es el documento original que recibe tu asesoría.',
  'purchases.fileNone': 'Sin archivo adjunto',
  'purchases.fileMissing': 'Sin archivo',
  'purchases.download': 'Descargar el original',
  'purchases.created': 'Factura de proveedor registrada',
  'purchases.updated': 'Factura de proveedor actualizada',
  'purchases.deleteConfirm': '¿Eliminar la factura {number} de {supplier}?\n\nTambién se elimina el archivo subido.',
  'purchases.deleted': 'Factura de proveedor eliminada',
  'purchases.totals.invoices': 'Facturas',
  'purchases.totals.net': 'Base',
  'purchases.totals.tax': 'IVA',
  'purchases.totals.gross': 'Total',
  'purchases.totals.outstanding': 'Pendiente de pago',
  'purchases.numberTaken': 'Ese proveedor ya tiene una factura con este número.',
  'status.pendingPayment': 'Pendiente',
  'status.paidPurchase': 'Pagada',

  // ── envío a la asesoría ───────────────────────────────────────────────────
  'nav.accounting': 'Asesoría',
  'accounting.title': 'Enviar a la asesoría',
  'accounting.subtitle': 'Elige el periodo, selecciona los documentos y envíalos en un único archivo.',
  'accounting.period': 'Periodo',
  'accounting.from': 'Desde',
  'accounting.to': 'Hasta',
  'accounting.quickYear': 'Año {year}',
  'accounting.quickQuarter': 'T{quarter} {year}',
  'accounting.onlyUnsent': 'Sólo documentos no enviados antes',
  'accounting.sales': 'Facturas emitidas a clientes',
  'accounting.purchases': 'Facturas recibidas de proveedores',
  'accounting.selectAll': 'Seleccionar todo',
  'accounting.selectNone': 'Quitar la selección',
  'accounting.selected': '{count} seleccionadas',
  'accounting.nothingSelected': 'Selecciona al menos un documento.',
  'accounting.noneInPeriod': 'No hay documentos en este periodo.',
  'accounting.alreadySent': 'Enviada el {date}',
  'accounting.noFileWarning': '{count} factura(s) de proveedor no tienen archivo adjunto. Sólo se incluyen sus datos.',
  'accounting.send': 'Enviar a la asesoría',
  'accounting.sending': 'Preparando y enviando…',
  'accounting.sent': '{count} documento(s) enviados a {to}',
  'accounting.archive': 'Archivo',
  'accounting.archiveHint': 'Un .zip con todos los documentos seleccionados y una hoja resumen.',
  'accounting.summaryFile': 'resumen.csv',
  'accounting.subject': 'Contabilidad {period} — {company}',
  'accounting.body': 'Hola:\n\nAdjuntamos la documentación {period}:\n\n· {salesCount} facturas emitidas, por un total de {salesTotal}\n· {purchasesCount} facturas recibidas, por un total de {purchasesTotal}\n\nEl archivo incluye también una hoja resumen.\n\nUn cordial saludo,\n{company}',
  'accounting.periodLabel': 'del {from} al {to}',
  'accounting.recipientMissing': 'Configura el correo de la asesoría en Configuración, o introduce uno abajo.',
  'settings.accounting': 'Asesoría',
  'settings.field.accountantName': 'Nombre de la asesoría',
  'settings.field.accountantEmail': 'Correo de la asesoría',
  'settings.accountingHint': 'Dirección a la que se envía la documentación contable por defecto.',

  // ── informes ──────────────────────────────────────────────────────────────
  'nav.reports': 'Informes',
  'reports.title': 'Informes por cliente',
  'reports.subtitle': 'Lo facturado a cada cliente, por año o en todo el periodo.',
  'reports.period': 'Periodo',
  'reports.allTime': 'Todo el periodo',
  'reports.year': 'Año {year}',
  'reports.client': 'Cliente',
  'reports.invoices': 'Facturas',
  'reports.net': 'Base',
  'reports.tax': 'IVA',
  'reports.gross': 'Total',
  'reports.paid': 'Cobrado',
  'reports.outstanding': 'Pendiente',
  'reports.first': 'Primera',
  'reports.last': 'Última',
  'reports.share': 'Peso',
  'reports.empty': 'No hay facturas en este periodo',
  'reports.emptyHint': 'Elige otro año, o todo el periodo.',
  'reports.download': 'Descargar CSV',
  'reports.totalsRow': 'Todos los clientes',
  'reports.clientHistory': '{name} — año por año',
  'reports.backToAll': 'Todos los clientes',
  'reports.averageInvoice': 'Factura media',
  'reports.noYears': 'No hay facturas registradas.',

  // ── servidor de correo ────────────────────────────────────────────────────
  'mail.title': 'Servidor de correo',
  'mail.subtitle': 'El servidor SMTP por el que se envían facturas, presupuestos y el envío a la gestoría.',
  'mail.enabled': 'Enviar correo por este servidor',
  'mail.disabledNote': 'El envío está desactivado. Las facturas y presupuestos se pueden seguir descargando en PDF.',
  'mail.connection': 'Conexión',
  'mail.host': 'Servidor',
  'mail.hostHint': 'El nombre o la dirección del servidor SMTP — smtp.ejemplo.com, o 127.0.0.1 si está en esta misma máquina.',
  'mail.port': 'Puerto',
  'mail.security': 'Cifrado',
  'mail.securityNone': 'Ninguno, o cifrar si el servidor lo ofrece',
  'mail.securityStarttls': 'STARTTLS — obligatorio',
  'mail.securityTls': 'TLS desde el inicio (normalmente el puerto 465)',
  'mail.username': 'Usuario',
  'mail.usernameHint': 'Déjalos en blanco si el servidor acepta correo sin autenticación.',
  'mail.password': 'Contraseña',
  'mail.passwordStored': 'Guardada. Déjala en blanco para conservarla, o escribe otra para sustituirla.',
  'mail.tlsServername': 'Nombre del certificado',
  'mail.tlsServernameHint': 'Sólo si el servidor presenta un certificado a nombre distinto del indicado arriba — un servidor de correo en esta máquina al que se llama por 127.0.0.1. En blanco, el certificado se comprueba contra el servidor indicado.',
  'mail.sender': 'Remitente',
  'mail.fromName': 'Nombre del remitente',
  'mail.fromEmail': 'Dirección del remitente',
  'mail.fromHint': 'El buzón autorizado por tu servidor: al que vuelven los rebotes y contra el que se comprueba el SPF. El cliente ve el nombre y el correo de la empresa de más arriba, no éste.',
  'mail.bcc': 'Copia oculta de cada mensaje a',
  'mail.bccHint': 'Opcional. Separa varias direcciones con comas.',
  'mail.test': 'Enviar un correo de prueba',
  'mail.testing': 'Enviando…',
  'mail.testTo': 'Enviar la prueba a',
  'mail.testOk': 'Mensaje de prueba enviado a {to}. Comprueba que ha llegado.',
  'mail.testFailed': 'No se ha podido usar el servidor de correo: {detail}',
  'mail.testNoRecipient': 'Indica una dirección a la que enviar la prueba.',
  'mail.notMigrated': 'No se puede guardar el servidor de correo hasta aplicar la actualización de base de datos db/10-mail-settings.sql.',
  'mail.testSubject': 'Mensaje de prueba de ARES Invoice',
  'mail.testBody': 'Este es un mensaje de prueba de ARES Invoice, enviado por {host}:{port}.\n\nSi lo estás leyendo, la aplicación puede enviar facturas y presupuestos por correo.',
  'mail.fromEnvironment': 'Estos valores vienen de las variables SMTP_* del fichero .env y se vuelven a leer en cada arranque. Al guardar este formulario dejan de usarse.',
  'mail.saveFirst': 'La prueba usa lo guardado, así que el formulario se guarda antes de lanzarla.',

  // ── copias de seguridad ───────────────────────────────────────────────────
  'backup.title': 'Copias de seguridad',
  'backup.subtitle': 'Un único archivo con la base de datos y todos los ficheros subidos.',
  'backup.enabled': 'Hacer copias automáticamente',
  'backup.disabledNote': 'Las copias automáticas están desactivadas. Aun así puedes lanzar una a mano.',
  'backup.destination': 'Dónde guardarlas',
  'backup.destinationHint': 'Conserva ambas: la copia local se restaura rápido y la remota sobrevive a la pérdida de este servidor.',
  'backup.noDestination': 'Activa al menos un destino.',
  'backup.localSection': 'En este servidor',
  'backup.sftpSection': 'En otro servidor (SFTP)',
  'backup.localEnabled': 'Guardar una copia en este servidor',
  'backup.sftpEnabled': 'Guardar una copia en otro servidor',
  'backup.localKeepCount': 'Copias que conservar aquí',
  'backup.sftpKeepCount': 'Copias que conservar allí',
  'backup.bothDestinations': 'local y remoto',
  'backup.destinationLocal': 'Un directorio de este servidor',
  'backup.destinationSftp': 'Otro servidor por SFTP',
  'backup.frequency': 'Con qué frecuencia',
  'backup.daily': 'Cada día',
  'backup.weekly': 'Cada semana',
  'backup.time': 'A las',
  'backup.dayOfWeek': 'El',
  'backup.keepCount': 'Copias que conservar',
  'backup.keepHint': 'Tras cada copia se eliminan las más antiguas del destino.',
  'backup.includeFiles': 'Incluir los ficheros subidos (logotipos, facturas de proveedores)',
  'backup.includeFilesHint': 'Sin ellos, una base de datos restaurada no puede mostrar el PDF de una factura de proveedor.',
  'backup.localPath': 'Directorio',
  'backup.localPathHint': 'Una ruta absoluta. Se crea si no existe.',
  'backup.sftpHost': 'Servidor',
  'backup.sftpPort': 'Puerto',
  'backup.sftpUsername': 'Usuario',
  'backup.sftpPath': 'Directorio remoto',
  'backup.sftpAuth': 'Autenticación',
  'backup.sftpAuthPassword': 'Contraseña',
  'backup.sftpAuthKey': 'Clave privada',
  'backup.sftpPassword': 'Contraseña',
  'backup.sftpPrivateKey': 'Clave privada',
  'backup.sftpPrivateKeyHint': 'Pega la clave completa, incluidas las líneas BEGIN y END.',
  'backup.sftpPassphrase': 'Frase de paso de la clave',
  'backup.secretStored': 'Guardada. Déjalo en blanco para mantenerla, o escribe una nueva para sustituirla.',
  'backup.secretCleared': 'Vaciar este campo elimina el valor guardado.',
  'backup.test': 'Probar el destino',
  'backup.testing': 'Probando…',
  'backup.testOk': 'Accesible y con permiso de escritura: {detail}',
  'backup.runNow': 'Hacer una copia ahora',
  'backup.running': 'Haciendo la copia…',
  'backup.ranOk': 'Copia terminada: {filename} ({size})',
  'backup.ranFailed': 'La copia ha fallado. Consulta el historial más abajo.',
  'backup.lastRun': 'Última copia',
  'backup.nextRun': 'Próxima copia',
  'backup.never': 'Nunca',
  'backup.history': 'Copias recientes',
  'backup.historyEmpty': 'Todavía no hay copias',
  'backup.historyEmptyHint': 'Lanza una a mano para comprobar que el destino funciona.',
  'backup.started': 'Inicio',
  'backup.contents': 'Contenido',
  'backup.contentsSummary': '{tables} tablas, {rows} filas, {files} ficheros',
  'backup.size': 'Tamaño',
  'backup.statusRunning': 'En curso',
  'backup.statusSuccess': 'Correcta',
  'backup.statusFailed': 'Fallida',
  'backup.triggerScheduled': 'Programada',
  'backup.triggerManual': 'Manual',
  'backup.download': 'Descargar una copia ahora',
  'backup.downloadHint': 'Genera un archivo y lo descarga aquí, sin tocar el destino.',
  'backup.localPathRequired': 'Introduce el directorio donde guardar las copias.',
  'backup.sftpIncomplete': 'Introduce al menos el servidor y el usuario del equipo remoto.',
  'backup.testFailed': 'No se ha podido acceder al destino: {detail}',
  'backup.restoreTitle': 'Restauración',
  'backup.restoreSteps': 'Descomprime el archivo, carga database.sql en una base de datos vacía y copia storage/ sobre el directorio de almacenamiento de la aplicación.',
  'backup.sunday': 'Domingo',
  'backup.monday': 'Lunes',
  'backup.tuesday': 'Martes',
  'backup.wednesday': 'Miércoles',
  'backup.thursday': 'Jueves',
  'backup.friday': 'Viernes',
  'backup.saturday': 'Sábado',

  // ── errores (servidor + cliente) ──────────────────────────────────────────
  'error.unexpected': 'Algo ha ido mal. Inténtalo de nuevo.',
  'error.network': 'No se puede contactar con el servidor.',
  'error.unauthorized': 'Inicia sesión para continuar.',
  'error.forbidden': 'No tienes acceso a eso.',
  'error.notFound': 'No encontrado.',
  'error.invalidCredentials': 'El usuario o la contraseña no son correctos.',
  'error.accountInactive': 'Esta cuenta ha sido desactivada.',
  'error.validation': 'Revisa los campos marcados.',
  'error.required': 'Este campo es obligatorio.',
  'error.invalidEmail': 'Introduce un correo electrónico válido.',
  'error.passwordTooShort': 'La contraseña debe tener al menos 8 caracteres.',
  'error.passwordMismatch': 'Las dos contraseñas no coinciden.',
  'error.usernameTaken': 'Ese nombre de usuario ya está en uso.',
  'error.emailTaken': 'Ese correo electrónico ya está en uso.',
  'error.clientNameTaken': 'Ya existe un cliente con ese nombre.',
  'error.productCodeTaken': 'Ya existe un producto con ese código.',
  'error.usernameFormat': 'Usa de 2 a 64 letras, dígitos, puntos, guiones o guiones bajos.',
  'error.invoiceNoLines': 'Una factura necesita al menos una línea.',
  'error.invoiceClientRequired': 'Selecciona un cliente.',
  'error.quantityPositive': 'La cantidad debe ser mayor que cero.',
  'error.pricePositive': 'El precio no puede ser negativo.',
  'error.taxRateRange': 'El IVA debe estar entre 0 y 100.',
  'error.unknownCurrency': 'Moneda desconocida.',
  'error.logoType': 'Sólo se aceptan imágenes PNG y JPEG.',
  'error.logoTooLarge': 'La imagen supera los 2 MB.',
  'error.inUse': 'Este registro está referenciado por otros datos y no se puede eliminar.',

  // ── VERI*FACTU (registro de facturación de la AEAT) ───────────────────────
  'nav.verifactu': 'VERI*FACTU',
  'verifactu.title': 'VERI*FACTU',
  'verifactu.subtitle': 'El registro de facturación de la AEAT. Cada factura emitida se remite como un registro de alta, encadenado al anterior.',
  'verifactu.enabled': 'Remitir las facturas a la AEAT',
  'verifactu.disabledNote': 'Desactivado. Las facturas se emiten como antes, sin registro de facturación ni código QR en el PDF.',
  'verifactu.onNote': 'Activado. Toda factura que se guarde a partir de ahora se remite, y una factura remitida ya no se puede modificar ni eliminar: se anula y se emite de nuevo.',

  'verifactu.connection': 'Conexión',
  'verifactu.environment': 'Entorno',
  'verifactu.environmentSandbox': 'Pruebas (homologación de la AEAT)',
  'verifactu.environmentProduction': 'Producción — los registros se remiten de verdad',
  'verifactu.environmentHint': 'El entorno de pruebas acepta su certificado real y devuelve errores de validación reales, pero no registra nada. Empiece por ahí.',
  'verifactu.endpoint': 'Punto de entrada',
  'verifactu.test': 'Probar la conexión',
  'verifactu.testing': 'Conectando…',
  'verifactu.testOk': 'La AEAT aceptó el certificado. Respondió: {detail}',
  'verifactu.testFailed': 'No se pudo conectar con la AEAT con este certificado: {detail}',
  'verifactu.testHint': 'Envía una petición vacía. Que la AEAT rechace su contenido es la respuesta esperada: significa que aceptó el certificado.',

  'verifactu.certificate': 'Certificado',
  'verifactu.certificateType': 'Tipo',
  'verifactu.certificateTypeCertificate': 'Certificado de persona física o jurídica',
  'verifactu.certificateTypeSeal': 'Certificado de sello',
  'verifactu.certificateTypeHint': 'Determina a qué servidor de la AEAT se envían los registros. El certificado de sello usa otro distinto.',
  'verifactu.certificateFile': 'Archivo del certificado',
  'verifactu.certificateFileHint': 'El .pfx o .p12 con su certificado de la AEAT y su clave privada. Se guarda cifrado y nunca se puede descargar.',
  'verifactu.certificatePassword': 'Contraseña del certificado',
  'verifactu.certificatePasswordHint': 'Se comprueba contra el archivo antes de guardar ninguno de los dos.',
  'verifactu.certificatePasswordStored': 'Guardada. Déjelo en blanco para mantenerla, o escriba otra para sustituirla.',
  'verifactu.certificateUpload': 'Subir certificado',
  'verifactu.certificateUploading': 'Comprobando…',
  'verifactu.certificateRemove': 'Eliminar certificado',
  'verifactu.certificateRemoveConfirm': '¿Eliminar el certificado guardado? La remisión queda desactivada hasta que se suba otro. Los registros ya remitidos no se ven afectados.',
  'verifactu.certificateNone': 'No hay ningún certificado guardado.',
  'verifactu.certificateStored': 'Titular: {subject}',
  'verifactu.certificateIssuedBy': 'Emitido por: {issuer}',
  'verifactu.certificateExpires': 'Caduca el {date}',
  'verifactu.certificateExpiresSoon': 'Caduca en {days} días: cuando caduque dejarán de remitirse los registros.',
  'verifactu.certificateHasExpired': 'Este certificado ha caducado. No se puede remitir nada hasta sustituirlo.',
  'verifactu.certificateUploaded': 'Certificado guardado.',

  'verifactu.issuer': 'Obligado a expedir',
  'verifactu.issuerNif': 'NIF',
  'verifactu.issuerNifHint': 'El NIF con el que se remiten los registros: nueve caracteres. En blanco se usa el NIF de la empresa de la sección Empresa.',
  'verifactu.issuerName': 'Nombre o razón social',
  'verifactu.issuerNameHint': 'En blanco se usa el nombre de la empresa.',
  'verifactu.effectiveIssuer': 'Los registros se remitirán como {name} ({nif}).',

  'verifactu.numbering': 'Numeración de las facturas',
  'verifactu.seriesPrefix': 'Prefijo de serie',
  'verifactu.seriesPrefixHint': 'Se antepone al número de factura para formar la serie que ve la AEAT. La serie y el número juntos deben ser únicos para este NIF para siempre, así que el prefijo importa si el NIF ya ha facturado desde otro sistema. Cambiarlo después no altera las facturas ya remitidas.',
  'verifactu.seriesExample': 'La factura 123 se remitiría como {example}.',

  'verifactu.tax': 'Impuestos',
  'verifactu.zeroRateCode': 'Las facturas al 0% son',
  'verifactu.zeroRateCodeHint': 'Qué comunicar a la AEAT sobre una factura sin IVA. Los códigos E son exenciones por el artículo indicado; los códigos N indican que la operación no está sujeta. Si nunca factura al 0%, esto no se usa.',
  'verifactu.zeroRateE1': 'E1 — exenta por el artículo 20',
  'verifactu.zeroRateE2': 'E2 — exenta por el artículo 21 (exportación)',
  'verifactu.zeroRateE3': 'E3 — exenta por el artículo 22',
  'verifactu.zeroRateE4': 'E4 — exenta por los artículos 23 y 24',
  'verifactu.zeroRateE5': 'E5 — exenta por el artículo 25 (entrega intracomunitaria)',
  'verifactu.zeroRateE6': 'E6 — exenta, otros',
  'verifactu.zeroRateN1': 'N1 — no sujeta por el artículo 7 o 14',
  'verifactu.zeroRateN2': 'N2 — no sujeta por reglas de localización',
  'verifactu.regimeKey': 'Régimen de IVA',
  'verifactu.regimeKeyHint': 'Se declara en cada factura. El 01 es el régimen general, con el que factura la mayoría.',

  'verifactu.system': 'Este programa',
  'verifactu.systemHint': 'Se identifica en cada registro, para que la AEAT sepa qué sistema lo generó. Los valores por omisión son correctos salvo que le hayan indicado otros.',
  'verifactu.systemName': 'Nombre del sistema',
  'verifactu.systemId': 'ID del sistema',
  'verifactu.systemIdHint': 'Dos caracteres, que distinguen este sistema de otros del mismo productor.',
  'verifactu.systemVersion': 'Versión',
  'verifactu.installationId': 'Número de instalación',
  'verifactu.producerName': 'Nombre del productor',
  'verifactu.producerNif': 'NIF del productor',
  'verifactu.producerHint': 'Quién produce el programa. Déjelos en blanco para un sistema de uso propio: entonces se toman del obligado a expedir.',

  'verifactu.autoSubmit': 'Remitir cada registro al guardar la factura',
  'verifactu.autoSubmitHint': 'Desactivado el registro se genera y se encadena igualmente, y espera a enviarse a mano. Útil mientras se prueba.',

  'verifactu.problems': 'Todavía no se puede usar',
  'verifactu.problemNoIssuerNif': 'Falta el NIF con el que remitir: rellene el NIF de la empresa, o el NIF de aquí.',
  'verifactu.problemBadIssuerNif': 'Ese NIF no es válido: compruebe los caracteres y la letra final.',
  'verifactu.problemNoIssuerName': 'Falta el nombre con el que remitir: rellene el nombre de la empresa, o el de aquí.',
  'verifactu.problemNoCertificate': 'No hay ningún certificado guardado.',
  'verifactu.problemCertificateUnreadable': 'El certificado guardado no se puede descifrar: SESSION_SECRET ha cambiado desde que se subió. Vuelva a subirlo.',
  'verifactu.problemCertificateExpired': 'El certificado guardado ha caducado.',
  'verifactu.certificatePasswordWrong': 'Esa contraseña no abre este certificado.',
  'verifactu.certificateUnreadable': 'Ese archivo no es un certificado PKCS#12 que se pueda leer.',
  'verifactu.seriesPrefixCharacters': 'Use sólo letras, dígitos y - _ . /',
  'verifactu.seriesNumberLength': 'La serie y el número juntos no caben en el campo de la AEAT (60 caracteres).',
  'verifactu.notMigrated': 'VERI*FACTU no se puede usar hasta aplicar la actualización de base de datos db/11-verifactu.sql.',
  'verifactu.notEnabled': 'VERI*FACTU está desactivado.',

  'verifactu.clientTaxIdMissing': 'El cliente de esta factura no tiene NIF. La AEAT identifica al destinatario de la factura, así que añádalo primero en el cliente.',
  'verifactu.clientTaxIdUnusable': 'El cliente de esta factura tiene un NIF que la AEAT no acepta. Hace falta un NIF español válido, o un NIF-IVA comunitario con su prefijo de país.',
  'verifactu.alreadyRegistered': 'Esta factura ya está remitida, o está esperando a remitirse.',
  'verifactu.notRegistered': 'Esta factura no está en el registro, así que no hay nada que anular.',
  'verifactu.alreadyCancelled': 'Esta factura ya se ha anulado.',
  'verifactu.invoiceLocked': 'Esta factura está remitida a la AEAT y ya no se puede modificar. Anúlela y emita una rectificativa.',
  'verifactu.invoiceLockedDelete': 'Esta factura está remitida a la AEAT y no se puede eliminar. Anúlela en su lugar, que es lo que deja el registro conforme con lo ocurrido.',

  // ── la página del registro ──
  'verifactu.register': 'Registro AEAT',
  'verifactu.registerSubtitle': 'Los registros de facturación remitidos por esta empresa, del más reciente al más antiguo. Sólo se añade: nada de aquí se puede modificar ni eliminar.',
  'verifactu.queuePending': 'En espera',
  'verifactu.queueAccepted': 'Remitidos',
  'verifactu.queueRejected': 'Rechazados',
  'verifactu.queueFailed': 'Detenidos',
  'verifactu.chainLength': 'Registros',
  'verifactu.chainHead': 'Última huella',
  'verifactu.status.pending': 'En espera',
  'verifactu.status.accepted': 'Remitido',
  'verifactu.status.warned': 'Remitido con avisos',
  'verifactu.status.rejected': 'Rechazado',
  'verifactu.status.failed': 'Detenido',
  'verifactu.type.alta': 'Alta',
  'verifactu.type.anulacion': 'Anulación',
  'verifactu.csv': 'CSV de la AEAT',
  'verifactu.recordAt': 'Generado',
  'verifactu.attempts': '{count} intentos',
  'verifactu.nextAttempt': 'Próximo intento {date}',
  'verifactu.send': 'Enviar ahora',
  'verifactu.sending': 'Enviando…',
  'verifactu.sent': 'Registro enviado.',
  'verifactu.subsanacion': 'Subsana un registro rechazado',
  'verifactu.noRecords': 'Todavía no se ha remitido nada',
  'verifactu.noRecordsHint': 'Los registros aparecen aquí a medida que se emiten facturas.',
  'verifactu.filterAll': 'Todos los registros',

  // ── en la factura ──
  'verifactu.invoiceNotFiled': 'Sin remitir',
  'verifactu.fileInvoice': 'Remitir a la AEAT',
  'verifactu.filing': 'Remitiendo…',
  'verifactu.filed': 'Factura {number} remitida a la AEAT.',
  'verifactu.withdrawInvoice': 'Anular en la AEAT',
  'verifactu.withdrawing': 'Anulando…',
  'verifactu.withdrawn': 'Factura {number} anulada en el registro de la AEAT.',
  'verifactu.withdrawConfirm': '¿Anular la factura {number} en el registro de la AEAT? La anulación se remite a su vez y no se puede deshacer: la sustituta hay que emitirla como una factura nueva.',
  'verifactu.invoiceCancelled': 'Anulada',
};
